module.exports = __webpack_public_path__ + "img/right.65bfbb66.png";